/*
  Jhango HF product card — dx3397 adaptation.
  Handles: inline option picker, availability, variant resolution,
  AJAX add-to-cart through the theme's cart-container element.
*/
(function () {
  'use strict'
  if (window._jhangoHfDx) return
  window._jhangoHfDx = true

  var OPT_KEYS = ['option1', 'option2', 'option3']

  function getVariants (card) {
    var el = document.getElementById(card.dataset.variantJsonId)
    if (!el) return []
    try { return JSON.parse(el.textContent) } catch (e) { return [] }
  }

  function optCount (card) {
    return card.querySelectorAll('.jhango-hf-opt-row').length
  }

  function setText (el, text) {
    if (!el) return
    el.textContent = text
    el.setAttribute('data-label', text)
  }

  function isMobile () {
    return window.matchMedia('(max-width: 600px)').matches
  }

  function atcLabel () {
    return isMobile() ? 'Add' : 'Add to Bag'
  }

  function syncAtcLabels (root) {
    root = root || document
    if (!root.querySelectorAll) return
    var mobile = isMobile()
    root.querySelectorAll('.jhango-hf-atc-text').forEach(function (el) {
      if (!el.dataset.full) el.dataset.full = el.getAttribute('data-label') || el.textContent
      var short = el.getAttribute('data-short') || el.dataset.full
      setText(el, mobile ? short : el.dataset.full)
    })
  }

  function resolveVariant (card) {
    var variants = getVariants(card)
    var sel = card._jhfSel || {}
    var n = optCount(card)
    return variants.find(function (v) {
      for (var i = 0; i < n; i++) {
        if (sel[i] == null || String(v[OPT_KEYS[i]]) !== String(sel[i])) return false
      }
      return true
    }) || null
  }

  function updateAvailability (card) {
    var variants = getVariants(card)
    var sel = card._jhfSel || {}
    var n = optCount(card)
    card.querySelectorAll('.jhango-hf-opt-btn').forEach(function (btn) {
      var oi = parseInt(btn.dataset.optIndex, 10)
      var val = btn.dataset.optValue
      var avail = variants.some(function (v) {
        if (v.available === false || String(v[OPT_KEYS[oi]]) !== String(val)) return false
        for (var k = 0; k < n; k++) {
          if (k !== oi && sel[k] != null && String(v[OPT_KEYS[k]]) !== String(sel[k])) return false
        }
        return true
      })
      btn.classList.toggle('jhango-hf-opt-btn--oos', !avail)
      btn.disabled = !avail
    })
  }

  function updateConfirm (card) {
    var confirm = card.querySelector('.jhango-hf-size-confirm')
    if (!confirm) return
    var sel = card._jhfSel || {}
    var n = optCount(card)
    var allSel = true
    for (var i = 0; i < n; i++) if (sel[i] == null) allSel = false
    var match = allSel ? resolveVariant(card) : null
    if (match && match.available) {
      confirm.dataset.variantId = match.id
      setText(confirm.querySelector('.jhango-hf-size-confirm-text'), atcLabel())
      setText(confirm.querySelector('.jhango-hf-size-confirm-price'), match.price || '')
      confirm.disabled = false
      confirm.classList.add('ready')
    } else {
      delete confirm.dataset.variantId
      setText(confirm.querySelector('.jhango-hf-size-confirm-text'), allSel ? 'Unavailable' : 'Select options')
      setText(confirm.querySelector('.jhango-hf-size-confirm-price'), '')
      confirm.disabled = true
      confirm.classList.remove('ready')
    }
  }

  function openPicker (card) {
    var form = card.querySelector('.jhango-hf-form')
    if (form) form.classList.add('size-open')
    updateAvailability(card)
    updateConfirm(card)
  }

  function closePicker (card) {
    if (!card) return
    var form = card.querySelector('.jhango-hf-form')
    if (form) form.classList.remove('size-open')
    card._jhfSel = {}
    card.querySelectorAll('.jhango-hf-opt-btn').forEach(function (b) {
      b.classList.remove('jhango-hf-opt-btn--active')
    })
    var conf = card.querySelector('.jhango-hf-size-confirm')
    if (conf) {
      conf.disabled = true
      conf.classList.remove('ready', 'loading')
      setText(conf.querySelector('.jhango-hf-size-confirm-text'), 'Select options')
      setText(conf.querySelector('.jhango-hf-size-confirm-price'), '')
      delete conf.dataset.variantId
    }
    updateAvailability(card)
  }

  async function doATC (form, variantId, trigger) {
    if (!variantId) return
    var card = form.closest('.jhango-hf-card')
    var atcBtn = form.querySelector('.jhango-hf-atc')
    var txt = atcBtn && atcBtn.querySelector('.jhango-hf-atc-text')
    var orig = txt ? txt.textContent : ''
    if (atcBtn) atcBtn.disabled = true
    if (txt) setText(txt, 'Adding…')
    if (trigger) trigger.classList.add('loading')

    var fd = new FormData()
    fd.append('id', variantId)
    fd.append('quantity', form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1)

    var cartContainer = document.querySelector('cart-container')
    try {
      if (cartContainer && typeof cartContainer.add === 'function') {
        await cartContainer.add(fd)
      } else {
        await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          body: fd
        })
        window.location.reload()
        return
      }
      if (txt) setText(txt, 'Added ✓')
    } catch (err) {
      console.error('JHF ATC:', err)
      if (txt) setText(txt, 'Error')
    } finally {
      if (trigger) trigger.classList.remove('loading')
      if (card) closePicker(card)
      setTimeout(function () {
        if (atcBtn) atcBtn.disabled = false
        if (txt) setText(txt, orig)
      }, 2000)
    }
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('.jhango-hf-atc')
    if (!atc || atc.disabled) return
    e.preventDefault()
    var form = atc.closest('.jhango-hf-form')
    var card = atc.closest('.jhango-hf-card')
    var inline = form && form.querySelector('.jhango-hf-size-inline')
    if (inline && !form.classList.contains('size-open')) {
      if (card) openPicker(card)
      return
    }
    var vi = form && form.querySelector('.jhango-hf-variant-input')
    doATC(form, vi ? vi.value : '')
  })

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jhango-hf-opt-btn')
    if (!btn || btn.disabled || btn.classList.contains('jhango-hf-opt-btn--oos')) return
    var card = btn.closest('.jhango-hf-card')
    var oi = parseInt(btn.dataset.optIndex, 10)
    card._jhfSel = card._jhfSel || {}
    card._jhfSel[oi] = btn.dataset.optValue
    card.querySelectorAll('.jhango-hf-opt-btn[data-opt-index="' + oi + '"]').forEach(function (b) {
      b.classList.remove('jhango-hf-opt-btn--active')
    })
    btn.classList.add('jhango-hf-opt-btn--active')
    updateAvailability(card)
    updateConfirm(card)
  })

  document.addEventListener('click', function (e) {
    if (e.target.closest('.jhango-hf-size-back')) {
      closePicker(e.target.closest('.jhango-hf-card'))
    }
  })

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jhango-hf-size-confirm.ready')
    if (!btn || btn.classList.contains('loading')) return
    var vid = btn.dataset.variantId
    if (!vid) return
    setText(btn.querySelector('.jhango-hf-size-confirm-text'), 'Adding…')
    doATC(btn.closest('.jhango-hf-form'), vid, btn)
  })

  document.addEventListener('submit', function (e) {
    if (e.target.closest('.jhango-hf-form')) e.preventDefault()
  })

  var resizeTimer
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function () { syncAtcLabels(document) }, 150)
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAtcLabels(document) })
  } else {
    syncAtcLabels(document)
  }
})()
